import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userAtom } from '@/recoil/atoms/user.atom';
import { message } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[]; // 추가: 허용된 역할 목록
  allowedCategories: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles, allowedCategories }) => {
  const user = useRecoilValue(userAtom);

  if (!user || !user.isAuth || !user.token) {
    message.warning('로그인 후 이용해 주세요.');
    return <Navigate to="/" replace />;
  }

  // 사용자 역할 확인
  if (user.role_name && user.category && (!allowedRoles.includes(user.role_name) || !allowedCategories.includes(user.category))) {
    message.warning('접근 권한이 없습니다.');
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
